module.exports = __webpack_public_path__ + "img/srbicon.dbb2ef2f.png";